import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { startStaleBuildMonitor } from '../utils/staleBuild';

export default function useStaleBuild() {
  const { pathname, search, hash } = useLocation();
  const monitor = useRef<ReturnType<typeof startStaleBuildMonitor>>(undefined);

  useEffect(() => {
    monitor.current = startStaleBuildMonitor();
    return () => monitor.current?.dispose();
  }, []);

  useEffect(() => {
    monitor.current?.navigate(`${pathname}${search}${hash}`);
  }, [pathname, search, hash]);
}
